import { createReducer, on } from '@ngrx/store';

import * as actions from './external-docs.actions';
import { externalDocsInitialState, ExternalDocsState } from './external-docs.state';
import { ExternalDocSearchInfo, ExternalDocPatientInfo, ExternalDocument } from '../../models/estensa-models.model';

export const externalDocsReducer = createReducer(
    externalDocsInitialState,
    on(actions.seOpenExternalDocsOnDialog, (state, { info, patientInfo, examinationsInfo }) => updateForShowExternalDocsDialog(state, info, patientInfo, examinationsInfo)),
    on(actions.seSetSelectExternalDoc, (state, { doc }) => updateForSelectedExternalDoc(state, doc)),
    on(actions.seSetSelectExternalDoc, (state, { doc }) => updateForSelectedExternalDoc(state, doc)),
    on(actions.seAddNewExternalDoc, (state, { doc }) => updateForSelectedExternalDoc(state, doc))
);

function updateForShowExternalDocsDialog(state: ExternalDocsState, info: ExternalDocSearchInfo, patientInfo: ExternalDocPatientInfo, examinationsInfo: string[] ) {
    return {
        info: info,
        patientInfo: patientInfo,
        examinationsInfo: examinationsInfo,
        selectedDoc: null
    };
}


function updateForSelectedExternalDoc(state: ExternalDocsState, doc: ExternalDocument) {
    return {
        ...state,
        selectedDoc: doc
    };
}




